/* ============================================================
   Craft Com — shared site logic (multi-page)
   ============================================================ */

/* ====== CONFIG ====== */
// ⚠️ Remplace par TON numéro WhatsApp, format international sans + ni espaces.
// France : 33 + ton numéro sans le 0 initial.  Ex : 33612345678
const WHATSAPP = "33652714361";

// Liens contact (page Contact) — remplace par tes vrais comptes.
const CONTACT = {
  instagram: "https://www.instagram.com/craftcom_/?hl=fr",        // ← ton lien Instagram complet
  snapchat:  "https://www.snapchat.com/@wacilrs?sender_web_id=17cdac2c-617c-41d6-ac1a-7add4b7911d6&device_type=desktop&is_copy_url=true",  // ← ton lien Snapchat
  email:     "craftcom.pro@gmail.com"             // ← ton email
};

// ⚠️ Colle ici la config de TON projet Firebase (Console Firebase > Paramètres du projet > Config SDK).
// Tant que ces valeurs sont des placeholders, le formulaire d'avis reste caché (aucune erreur affichée aux visiteurs).
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBE_UywizobsH3v2pyVTtX3gQl02JCAWNY",
  authDomain: "craft-com.firebaseapp.com",
  projectId: "craft-com",
  storageBucket: "craft-com.firebasestorage.app",
  messagingSenderId: "1036506270984",
  appId: "1:1036506270984:web:3395cd6ab9527f90e470bd"
};
const FIREBASE_ENABLED = !!(FIREBASE_CONFIG.apiKey && FIREBASE_CONFIG.apiKey.indexOf('TON_') !== 0);
let _db = null;
if (FIREBASE_ENABLED && window.firebase) {
  try {
    firebase.initializeApp(FIREBASE_CONFIG);
    _db = firebase.firestore();
  } catch (e) { console.warn('Firebase init a échoué', e); }
}
function loadPublicReviews(callback) {
  if (!_db) { callback([]); return; }
  _db.collection('reviews').orderBy('createdAt', 'desc').limit(50).get()
    .then(snap => { const list = []; snap.forEach(doc => list.push(doc.data())); callback(list); })
    .catch(err => { console.warn('Chargement avis Firestore échoué', err); callback([]); });
}
function submitPublicReview(review) {
  if (!_db) return Promise.reject(new Error('Firebase non configuré'));
  return _db.collection('reviews').add({ ...review, createdAt: firebase.firestore.FieldValue.serverTimestamp() });
}
const SERVICES = [
  {id:'flyer',  name:'Flyer',                         price:45,  unit:null,    desc:'Création visuelle 9:16'},
  {id:'board',  name:'Menu board digital',            price:150, unit:'écran', desc:'Affichage dynamique'},
  {id:'print',  name:'Menu print',                    price:50,  unit:'page',  desc:'Carte imprimable'},
  {id:'banner', name:'Bannière Uber Eats / Deliveroo',price:40,  unit:null,    desc:'Header plateforme'},
  {id:'photo',  name:'Photo produit',                 price:10,  unit:'photo', desc:'Retouche incluse'},
  {id:'snap',   name:'Filtre Snapchat',               price:20,  unit:null,    desc:'Filtre personnalisé'},
  {id:'video',  name:'Vidéo IA',                      price:250, unit:null,    desc:'Contenu généré + montage'},
  {id:'shopify',name:'Site Shopify',                  price:300, unit:null,    desc:'Boutique en ligne'},
  {id:'autres', name:'Autres projets',                price:null,unit:null,    desc:'Brief sur mesure', quote:true},
];
// Réalisations classées par catégorie. Les images viennent de window.CRAFTCOM_GALLERY
// (injecté par le thème). Pour ajouter une catégorie d'images, ajoute-la là + ici.
const CATEGORIES = [
  {id:'flyers',  name:'Flyers',          sub:'Affiches & visuels 9:16',     c1:'#7b1fa2',c2:'#1c1030'},
  {id:'video',   name:'Vidéos',          sub:'Montage & contenu IA',        c1:'#1f8a9e',c2:'#04161a'},
  {id:'shopify', name:'Sites & boutiques',sub:'Shopify & web premium',      c1:'#3a4cd1',c2:'#070b22'},
  {id:'menus',   name:'Menus & cartes',  sub:'Cartes digitales & imprimées',c1:'#d98a00',c2:'#2a1700'},
  {id:'social',  name:'Réseaux sociaux', sub:'Posts & formats verticaux',   c1:'#b8002e',c2:'#2a0610'},
];
function galleryFor(id){ return (window.CRAFTCOM_GALLERY && window.CRAFTCOM_GALLERY[id]) || []; }
function coverFor(id){ return (window.CRAFTCOM_GALLERY && window.CRAFTCOM_GALLERY.covers && window.CRAFTCOM_GALLERY.covers[id]) || ''; }
// Résout un nom de fichier ('logo.png') vers l'URL des assets du thème.
// Une URL complète (https://...) est laissée telle quelle.
function assetURL(name){
  if(!name) return '';
  if(/^(https?:)?\/\//.test(name) || name.charAt(0)==='/') return name;
  return (window.CRAFTCOM_ASSET_BASE || '') + name;
}
const REVIEWS = [
  {n:'Ali B.', t:'Atelier Vert — Espaces verts',    s:5, q:"Flyer et direction artistique complète qui nous ont permis d'attirer de nombreux clients. C'est exactement l'image premium que nous voulions transmettre."},
  {n:'Sofia M.', t:'El Riadh — Restaurant',    s:5, q:"Notre menu Ramadan a fait un carton sur Instagram. Réactif, à l'écoute, et un sens du détail rare."},
  {n:'Karim D.', t:'Gold Chicken — Fast-food', s:5, q:"Bornes et flyers refaits par Craft Com. Le rendu est ultra propre, on a senti la différence sur les commandes dès la première semaine."},
  {n:'Lina R.',  t:'La Perle — Parfumerie',s:5, q:"Direction artistique au top, on parle le même langage. Ma marque a gagné en cohérence et en cachet."},
  {n:'Mehdi T.', t:'MCDF — Sneakers',         s:5, q:"Une vraie identité de marque, premium et reconnaissable. Exactement ce qu'on cherchait pour se démarquer."},
  {n:'Samy K.',  t:'G & K Motors — Auto / Lavage',    s:5, q:"Flyer, carte de visite, filtre snapchat, tout est carré. Délais respectés et résultat au-dessus de nos attentes."},
];
// Logos clients — remplace par tes vrais logos (PNG) quand tu veux.
const CLIENTS = [
  {name:'La Perle',        sub:'Parfumerie',     c:'#d9b86b', img:'cc-logo-laperle.jpg'},
  {name:'Footify',         sub:'Maillots foot',  c:'#7bd13a', img:'cc-logo-footify.png'},
  {name:'G & K Motors',    sub:'Auto / Lavage',  c:'#2f8ae6', img:'cc-logo-gmotors.jpg'},
  {name:'Kiosk',           sub:'Épicerie',        c:'#27c2ff', img:'cc-logo-kiosk.jpg'},
  {name:'KAP Carrelage',   sub:'Carrelage',      c:'#e8852f', img:'cc-logo-kap.jpg'},
  {name:'Quai du M²',      sub:'Matériaux',      c:'#1f3a4d', img:'cc-logo-quaidum2.jpg'},
  {name:'Atelier Vert',    sub:'Espaces verts',  c:'#34d399', img:'cc-logo-ateliervert.jpg'},
  {name:'Booster',         sub:'Streameur',      c:'#e23b3b', img:'cc-logo-booster.jpg'},
  {name:'El Riadh',        sub:'Restaurant',     c:'#7b2fd1', img:'cc-logo-elriadh.png'},
  {name:'King Burger',     sub:'Fast-food',      c:'#ff4d2e', img:'cc-logo-kingburger.jpg'},
  {name:'HM Elec',         sub:'Électricité',    c:'#f5d020', img:'cc-logo-hmelec.jpg'},
  {name:'KFB',             sub:'Fast-food',      c:'#e8852f', img:'cc-logo-kfb.jpg'},
  {name:'YM Location',     sub:'Location auto',  c:'#cbb89a', img:'cc-logo-ymlocation.jpg'},
  {name:'MCDF',            sub:'Sneakers',       c:'#c0392b', img:'cc-logo-mcdf.jpg'},
  {name:'SOS Crevaison',   sub:'Dépannage',      c:'#e23b3b', img:'cc-logo-soscrevaison.jpg'},
  {name:'OBAK Burger',      sub:'Fast-food',      c:'#ffcf00', img:'cc-logo-bakburger.png'},
  {name:'Crispy Corner',   sub:'Fast-food',      c:'#ff3fae', img:'cc-logo-crispycorner.png'},
  {name:'SD Dépannage',     sub:'Dépannage',         c:'#e82f2fff', img:'cc-logo-sddepannage.png'},
];

const eur = n => n.toLocaleString('fr-FR') + '\u00A0€';

/* ====== STATE (persisté entre les pages) ====== */
const SKEY='craftcom_sel';
function defaultState(){const s={};SERVICES.forEach(x=>s[x.id]={sel:false,qty:1});return s;}
function loadState(){ try{const v=JSON.parse(localStorage.getItem(SKEY));return v||{};}catch(e){return {};} }
let state = (()=>{const d=defaultState();const s=loadState();SERVICES.forEach(x=>{if(s[x.id])d[x.id]=s[x.id];});return d;})();
function saveState(){ try{localStorage.setItem(SKEY,JSON.stringify(state));}catch(e){} }

function computeTotals(){
  let total=0,count=0,hasQuote=false;const lines=[],rows=[];
  SERVICES.forEach(s=>{
    const st=state[s.id];if(!st||!st.sel)return;count++;
    if(s.quote){hasQuote=true;lines.push(`• ${s.name} — sur devis`);
      rows.push({name:s.name,price:'Sur devis',quote:true});return;}
    const line=s.price*(s.unit?st.qty:1);total+=line;
    const sub=s.unit?`${st.qty} × ${s.price}\u00A0€ / ${s.unit}`:'';
    lines.push(`• ${s.name}${s.unit?` ×${st.qty}`:''} — ${eur(line)}`);
    rows.push({name:s.name,sub,price:eur(line)});
  });
  return {total,count,hasQuote,lines,rows};
}
function waLink(text){return `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;}
function selectionSummary(){const t=computeTotals();
  return t.lines.length ? t.lines.join('\n') + (t.total?`\nTotal estimé : ${eur(t.total)}`:'') : '';}

/* ====== NAV (active + burger + scroll) ====== */
(function(){
  const nav=document.getElementById('nav');
  if(nav) addEventListener('scroll',()=>nav.classList.toggle('scrolled',scrollY>40),{passive:true});
  const burger=document.getElementById('burger'),navlinks=document.getElementById('navlinks');
  if(burger&&navlinks){
    burger.addEventListener('click',()=>navlinks.classList.toggle('open'));
    navlinks.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>navlinks.classList.remove('open')));
  }
  // active link
  let page=location.pathname.split('/').pop()||'index.html';
  if(page==='') page='index.html';
  document.querySelectorAll('#navlinks a[data-page]').forEach(a=>{
    if(a.dataset.page===page) a.classList.add('active');
  });
})();

/* ====== FLOATING STACK (toutes les pages) ====== */
function renderFloat(){
  const nfcCart=document.getElementById('nfcCart');
  if(nfcCart){
    fetch('/cart.js').then(r=>r.json()).then(c=>{
      const hasNfc=c.items.some(i=>{
        const title=(i.product_title||'').toLowerCase();
        const handle=(i.handle||'').toLowerCase();
        return title.includes('nfc') || handle.includes('nfc') || title.includes('plaque');
      });
      nfcCart.classList.toggle('show',hasNfc);
    });
  }
  const cart=document.getElementById('cart');
  const waCard=document.getElementById('waCard');
  const t=computeTotals();
  if(cart){
    const cv=document.getElementById('cartVal'),cb=document.getElementById('cartBadge');
    if(cv) cv.innerHTML=eur(t.total);
    if(cb) cb.textContent=t.count;
    cart.classList.toggle('show',t.count>0);
    document.dispatchEvent(new CustomEvent('craftcom:selection-updated'));
  }
  if(waCard){
    const sum=selectionSummary();
    const quick="Bonjour Craft Com 👋\nJe suis intéressé(e) par vos services."+(sum?`\n\nMa sélection :\n${sum}`:'');
    waCard.href=waLink(quick);
  }
  document.querySelectorAll('[data-wa-link]').forEach(a=>{
    const sum=selectionSummary();
    a.href=waLink("Bonjour Craft Com 👋\nJe vous contacte au sujet d'un projet."+(sum?`\n\nMa sélection :\n${sum}`:''));
  });
}
(function(){
  const cart=document.getElementById('cart');
  if(cart) cart.addEventListener('click',()=>{const d=document.getElementById('devis');if(d){d.scrollIntoView({behavior:'smooth'});}else{location.href='/pages/services#devis';}});
})();

/* ====== SCROLL REVEAL ====== */
const _io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');_io.unobserve(e.target);}}),{threshold:.16});
function observeReveals(root=document){root.querySelectorAll('.reveal:not(.in)').forEach(el=>_io.observe(el));}

/* ====== SERVICES GRID (page services) ====== */
function buildServices(){
  const grid=document.getElementById('svcGrid');if(!grid)return;
  SERVICES.forEach(s=>{
    const st=state[s.id];
    const el=document.createElement('div');
    el.className='svc'+(st.sel?' sel':'');el.dataset.id=s.id;el.tabIndex=0;el.setAttribute('role','button');el.setAttribute('aria-pressed',st.sel);
    const priceHtml=s.quote
      ? `<div class="svc-price quote"><span class="amt">Sur devis</span></div>`
      : `<div class="svc-price"><span class="amt">${s.price}\u00A0€</span>${s.unit?`<span class="unit">/ ${s.unit}</span>`:''}</div>`;
    const qtyHtml=s.unit
      ? `<div class="svc-qty has"><span class="lbl">Quantité</span>
           <div class="stepper"><button data-act="-" aria-label="moins">−</button><span class="qv">${st.qty}</span><button data-act="+" aria-label="plus">+</button></div></div>`
      : `<div class="svc-qty"></div>`;
    el.innerHTML=`
      <div class="svc-top">
        <div><div class="svc-name">${s.name}</div>
        <div style="color:var(--steel);font-size:.8rem;margin-top:5px">${s.desc}</div></div>
        <div class="svc-tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
      </div>${priceHtml}${qtyHtml}`;
    grid.appendChild(el);

    const sync=()=>{el.classList.toggle('sel',state[s.id].sel);el.setAttribute('aria-pressed',state[s.id].sel);saveState();renderFloat();};
    const toggle=()=>{state[s.id].sel=!state[s.id].sel;sync();};
    el.addEventListener('click',e=>{if(e.target.closest('.stepper'))return;toggle();});
    el.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
    if(s.unit){
      const qv=el.querySelector('.qv');
      el.querySelectorAll('.stepper button').forEach(b=>b.addEventListener('click',e=>{
        e.stopPropagation();const st2=state[s.id];
        st2.qty=Math.max(1,st2.qty+(b.dataset.act==='+'?1:-1));qv.textContent=st2.qty;
        if(!st2.sel) st2.sel=true; sync();
      }));
    }
  });
}

/* ====== RÉALISATIONS : catégories + galerie ====== */
function buildPortfolio(){
  const track=document.getElementById('pfTrack');if(!track)return;
  CATEGORIES.forEach(cat=>{
    const imgs=galleryFor(cat.id);
    const count=imgs.length;
    let cover=coverFor(cat.id);
    if(!cover && imgs[0]){ const f=galItem(imgs[0]); cover = f.type==='video' ? f.poster : f.src; }
    const c=document.createElement('article');
    c.className='pf-card'+(count?'':' soon');
    const bg = cover
      ? `background-image:url('${cover}');background-size:cover;background-position:center`
      : `background:
        radial-gradient(120% 90% at 30% 20%, ${cat.c1}, transparent 60%),
        radial-gradient(120% 100% at 80% 90%, ${cat.c2}, #04060a 80%),
        linear-gradient(160deg, ${cat.c2}, #04060a)`;
    c.innerHTML=`
      <div class="pf-bg" style="${bg}"></div>
      <div class="pf-grain"></div><div class="pf-glow"></div>
      ${count?`<span class="pf-count">${count} réalisation${count>1?'s':''}</span>`:`<span class="pf-count soon">Bientôt</span>`}
      <div class="pf-meta">
        <span class="pf-tag">${cat.sub}</span>
        <h3>${cat.name}</h3>
        ${count?`<span class="pf-see">Voir la galerie <svg width="16" height="11" viewBox="0 0 24 14" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M2 7h18M15 2l5 5-5 5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`:`<span class="pf-see soon">Disponible prochainement</span>`}
      </div>`;
    if(count){ c.addEventListener('click',()=>{ if(track._moved) return; openGallery(cat); }); }
    track.appendChild(c);
  });
  // glisser pour scroller — SANS capture du pointeur, sinon le clic n'atteint pas la carte
  let down=false,sx=0,sl=0;
  track._moved=false;
  track.addEventListener('pointerdown',e=>{down=true;track._moved=false;sx=e.clientX;sl=track.scrollLeft;});
  track.addEventListener('pointermove',e=>{if(!down)return;if(Math.abs(e.clientX-sx)>6){track._moved=true;track.classList.add('drag');}track.scrollLeft=sl-(e.clientX-sx);});
  const up=()=>{down=false;setTimeout(()=>{track.classList.remove('drag');track._moved=false;},60);};
  window.addEventListener('pointerup',up);
  track.addEventListener('pointercancel',up);
  // flèches du carrousel
  const prev=document.getElementById('pfPrev'), next=document.getElementById('pfNext');
  function pfStep(dir){
    const card=track.querySelector('.pf-card');
    const w=card ? card.getBoundingClientRect().width + 22 : 340;
    track.scrollBy({left:dir*w, behavior:'smooth'});
  }
  function pfArrows(){
    if(!prev||!next) return;
    const max=track.scrollWidth - track.clientWidth - 2;
    prev.classList.toggle('hidden', track.scrollLeft<=2);
    next.classList.toggle('hidden', track.scrollLeft>=max || max<=0);
  }
  if(prev) prev.addEventListener('click',()=>pfStep(-1));
  if(next) next.addEventListener('click',()=>pfStep(1));
  track.addEventListener('scroll',pfArrows,{passive:true});
  window.addEventListener('resize',pfArrows);
  pfArrows();
}

/* ====== GALERIE plein écran + lightbox ====== */
let _galImgs=[], _galItems=[], _galIndex=0;
function galItem(e){
  if(e && typeof e==='object'){
    if(e.url) return {type:'link', src:(e.logo||e.poster||''), poster:(e.logo||e.poster||''), url:e.url};
    return {type:'video', src:e.src, poster:e.poster||''};
  }
  const s=String(e);
  if(/\.mp4(\?|$)/i.test(s)) return {type:'video', src:s, poster:''};
  return {type:'image', src:s, poster:''};
}
function ensureGalleryDOM(){
  if(document.getElementById('galOverlay')) return;
  const o=document.createElement('div'); o.id='galOverlay'; o.className='gal-overlay';
  o.innerHTML=`
    <div class="gal-head">
      <div><span class="gal-eyebrow">Réalisations</span><h3 id="galTitle"></h3></div>
      <button class="gal-close" id="galClose" aria-label="Fermer">&times;</button>
    </div>
    <div class="gal-grid" id="galGrid"></div>
    <div class="gal-light" id="galLight">
      <button class="gal-x" id="galLightClose" aria-label="Fermer">&times;</button>
      <button class="gal-nav prev" id="galPrev" aria-label="Précédent">&#8249;</button>
      <img id="galLightImg" alt="">
      <video id="galLightVid" controls playsinline preload="metadata"></video>
      <button class="gal-nav next" id="galNext" aria-label="Suivant">&#8250;</button>
    </div>`;
  document.body.appendChild(o);
  document.getElementById('galClose').addEventListener('click',closeGallery);
  o.addEventListener('click',e=>{if(e.target===o)closeGallery();});
  document.getElementById('galLightClose').addEventListener('click',closeLight);
  document.getElementById('galLight').addEventListener('click',e=>{if(e.target.id==='galLight')closeLight();});
  document.getElementById('galPrev').addEventListener('click',()=>stepLight(-1));
  document.getElementById('galNext').addEventListener('click',()=>stepLight(1));
  document.addEventListener('keydown',e=>{
    if(document.getElementById('galLight').classList.contains('open')){
      if(e.key==='Escape')closeLight(); if(e.key==='ArrowLeft')stepLight(-1); if(e.key==='ArrowRight')stepLight(1);
    } else if(o.classList.contains('open') && e.key==='Escape') closeGallery();
  });
}
function openGallery(cat){
  ensureGalleryDOM();
  _galImgs=galleryFor(cat.id);
  _galItems=_galImgs.map(galItem);
  document.getElementById('galTitle').textContent=cat.name;
  const grid=document.getElementById('galGrid'); grid.innerHTML='';
  _galItems.forEach((it,i)=>{
    const t=document.createElement('button'); t.className='gal-thumb';
    if(it.type==='link'){
      t.classList.add('is-link');
      t.innerHTML=`<img loading="lazy" src="${it.src}" alt="${cat.name} ${i+1}"><span class="gal-link-badge" aria-hidden="true">↗</span>`;
      t.addEventListener('click',()=>window.open(it.url,'_blank','noopener'));
    } else if(it.type==='video'){
      t.classList.add('is-video');
      t.innerHTML=(it.poster
        ?`<img loading="lazy" src="${it.poster}" alt="${cat.name} ${i+1}">`
        :`<span class="gal-vthumb"></span>`)+`<span class="gal-play" aria-hidden="true"></span>`;
      t.addEventListener('click',()=>openLight(i));
    } else {
      t.innerHTML=`<img loading="lazy" src="${it.src}" alt="${cat.name} ${i+1}">`;
      t.addEventListener('click',()=>openLight(i));
    }
    grid.appendChild(t);
  });
  grid.scrollTop=0;
  document.getElementById('galOverlay').classList.add('open');
  document.body.style.overflow='hidden';
}
function closeGallery(){closeLight();document.getElementById('galOverlay').classList.remove('open');document.body.style.overflow='';}
function renderLight(){
  const it=_galItems[_galIndex]||{type:'image',src:_galImgs[_galIndex]};
  const img=document.getElementById('galLightImg'), vid=document.getElementById('galLightVid');
  if(it.type==='video'){
    img.style.display='none'; img.removeAttribute('src');
    vid.style.display='block'; vid.src=it.src; if(it.poster)vid.poster=it.poster;
    try{vid.currentTime=0; vid.play().catch(()=>{});}catch(e){}
  } else {
    vid.pause(); vid.style.display='none'; vid.removeAttribute('src'); vid.removeAttribute('poster');
    img.style.display='block'; img.src=it.src;
  }
}
function openLight(i){_galIndex=i;renderLight();document.getElementById('galLight').classList.add('open');}
function stepLight(d){_galIndex=(_galIndex+d+_galItems.length)%_galItems.length;renderLight();}
function closeLight(){const v=document.getElementById('galLightVid');if(v){v.pause();}const l=document.getElementById('galLight');if(l)l.classList.remove('open');}

/* ====== REVIEWS (page avis) ====== */
function reviewCardHTML(r){
  const star='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
  const esc=s=>String(s).replace(/[<>&"]/g,c=>({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c]));
  return `<div class="stars">${star.repeat(r.s)}</div><p>${esc(r.q)}</p>`+
    `<div class="rev-by"><div class="rev-av">${esc((r.n[0]||'?').toUpperCase())}</div>`+
    `<div><div class="n">${esc(r.n)}</div><div class="t">${esc(r.t)}</div></div></div>`;
}
function buildReviews(){
  const g=document.getElementById('revGrid');if(!g)return;
  REVIEWS.forEach((r,i)=>{
    const el=document.createElement('div');el.className='rev reveal';el.dataset.d=((i%3)+1);
    el.innerHTML=reviewCardHTML(r);
    g.appendChild(el);
  });
  // Avis publiés par les visiteurs (Firestore), visibles par tout le monde, affichés en premier.
  loadPublicReviews(list=>{
    list.forEach(r=>{
      const el=document.createElement('div');el.className='rev reveal in';
      el.innerHTML=reviewCardHTML({n:r.n||'Client',t:r.t||'Client',s:r.s||5,q:r.q||''});
      g.insertBefore(el, g.firstChild);
    });
  });
}

/* ====== CLIENTS MARQUEE (accueil) ====== */
function buildClients(){
  const track=document.getElementById('marqueeTrack');if(!track)return;
  const card=c=>`<div class="client" title="${c.name}">
      <span class="cmark${c.img?' logo-mark':''}"${c.img?'':` style="background:linear-gradient(135deg,${c.c},#ffffff22)"`}>${c.img?`<img src="${assetURL(c.img)}" alt="${c.name}">`:c.name[0]}</span>
      <span><span class="cname">${c.name}</span><span class="csub">${c.sub}</span></span></div>`;
  const html=CLIENTS.map(card).join('');track.innerHTML=html+html;
}

/* ====== DEVIS (page devis) ====== */
function buildDevis(){
  const formBody=document.getElementById('formBody');if(!formBody)return;
  const form={social:null,pseudo:'',deadline:null,budget:null};
  const recapList=document.getElementById('recapList');
  const recapTotal=document.getElementById('recapTotal');
  const recapNote=document.getElementById('recapNote');
  const fServices=document.getElementById('f-services');

  function renderRecap(){
    const t=computeTotals();recapList.innerHTML='';
    if(t.count===0){recapList.innerHTML='<div class="recap-empty">Aucune prestation sélectionnée. <a href="#services" style="color:var(--turq)">Choisir mes prestations →</a></div>';}
    else t.rows.forEach(r=>{
      const sub=r.sub?` <small>${r.sub}</small>`:'';
      recapList.insertAdjacentHTML('beforeend',
        `<div class="recap-row"><span class="nm">${r.name}${sub}</span><span class="pr${r.quote?' q':''}">${r.price}</span></div>`);
    });
    recapTotal.innerHTML=eur(t.total);
    recapNote.textContent=t.hasQuote?'Hors « Autres projets » (sur devis). Estimation indicative TTC.':'Estimation indicative TTC.';
    fServices.value=t.lines.length? t.lines.join('\n')+(t.total?`\n\nTotal estimé : ${eur(t.total)}`:'') : '';
  }
  renderRecap();
  document.addEventListener('craftcom:selection-updated', renderRecap);

  // social toggle
  const socField=document.getElementById('socField'),pseudo=document.getElementById('f-pseudo');
  document.querySelectorAll('.soc-opt').forEach(btn=>btn.addEventListener('click',()=>{
    const soc=btn.dataset.soc;
    document.querySelectorAll('.soc-opt').forEach(b=>{b.classList.toggle('on',b===btn);b.setAttribute('aria-pressed',b===btn);});
    form.social=soc;socField.classList.add('show');pseudo.disabled=false;
    pseudo.placeholder=soc==='snap'?'Ton pseudo Snapchat':'Ton pseudo Instagram';
    pseudo.value='';form.pseudo='';pseudo.focus();
  }));
  pseudo.addEventListener('input',()=>form.pseudo=pseudo.value);

  // chips
  document.querySelectorAll('.chips').forEach(group=>{
    const key=group.dataset.key;
    group.querySelectorAll('.chip').forEach(chip=>chip.addEventListener('click',()=>{
      const on=chip.classList.contains('on');
      group.querySelectorAll('.chip').forEach(c=>c.classList.remove('on'));
      if(!on){chip.classList.add('on');form[key]=chip.dataset.val;} else form[key]=null;
    }));
  });

  // file upload
  const drop=document.getElementById('drop'),fileInput=document.getElementById('f-file'),fileList=document.getElementById('fileList');
  drop.addEventListener('click',()=>fileInput.click());
  const showFiles=fl=>{fileList.innerHTML='';[...fl].slice(0,6).forEach(f=>{const s=document.createElement('span');s.textContent=f.name.length>22?f.name.slice(0,20)+'…':f.name;fileList.appendChild(s);});};
  fileInput.addEventListener('change',()=>showFiles(fileInput.files));
  ['dragover','dragenter'].forEach(ev=>drop.addEventListener(ev,e=>{e.preventDefault();drop.classList.add('over');}));
  ['dragleave','drop'].forEach(ev=>drop.addEventListener(ev,e=>{e.preventDefault();drop.classList.remove('over');}));
  drop.addEventListener('drop',e=>{if(e.dataTransfer.files.length){fileInput.files=e.dataTransfer.files;showFiles(e.dataTransfer.files);}});

  // submit -> whatsapp
  function flagError(el){el.style.borderColor='var(--gold)';el.focus();el.addEventListener('input',()=>el.style.borderColor='',{once:true});}
  document.getElementById('sendBtn').addEventListener('click',()=>{
    const name=document.getElementById('f-name').value.trim();
    const biz=document.getElementById('f-biz').value.trim();
    const wa=document.getElementById('f-wa').value.trim();
    const mail=document.getElementById('f-mail').value.trim();
    const msg=document.getElementById('f-msg').value.trim();
    if(!name){flagError(document.getElementById('f-name'));return;}
    if(!form.social){const t=document.getElementById('socialToggle');t.scrollIntoView({behavior:'smooth',block:'center'});
      t.animate([{transform:'translateX(0)'},{transform:'translateX(-6px)'},{transform:'translateX(6px)'},{transform:'translateX(0)'}],{duration:300});return;}
    const socName=form.social==='snap'?'Snapchat':'Instagram';
    const L=['🟢 *Nouvelle demande de devis — Craft Com*','',`👤 Nom : ${name}`];
    if(biz) L.push(`🏢 Entreprise : ${biz}`);
    L.push(`📲 ${socName} : ${form.pseudo||'(non renseigné)'}`);
    if(wa) L.push(`📞 WhatsApp : ${wa}`);
        if(mail) L.push(`📧 E-mail : ${mail}`);
    L.push('','📦 *Prestations :*', selectionSummary()||'(à définir ensemble)');
    if(form.deadline) L.push(`\n⏱️ Deadline : ${form.deadline}`);
    if(form.budget)   L.push(`💶 Budget estimé : ${form.budget}`);
    if(msg){L.push('',`📝 Projet : ${msg}`);}
    const files=fileInput.files;if(files&&files.length) L.push(`\n📎 ${files.length} fichier(s) à envoyer dans la conversation.`);
    window.open(waLink(L.join('\n')),'_blank','noopener');
    formBody.style.display='none';
    document.getElementById('formOk').classList.add('show');
  });
}

/* ====== GALAXY (Three.js) ====== */
function initGalaxy(){
  const canvas=document.getElementById('galaxy');if(!canvas)return;
  const ambient=canvas.classList.contains('bg-fixed');
  const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(!window.THREE){
    // Three.js pas encore chargé : on attend qu'il arrive (ordre de script indépendant)
    if(!canvas.dataset.tries) canvas.dataset.tries='0';
    const tries=parseInt(canvas.dataset.tries,10);
    if(tries<150){ canvas.dataset.tries=(tries+1); setTimeout(initGalaxy,50); return; }
    canvas.style.background='radial-gradient(120% 80% at 50% 30%,#0a2a2c,#05080a)';return;
  }
  const renderer=new THREE.WebGLRenderer({canvas,antialias:true,alpha:true});
  renderer.setPixelRatio(Math.min(devicePixelRatio,2));
  const scene=new THREE.Scene();scene.fog=new THREE.FogExp2(0x05080a,0.018);
  const camera=new THREE.PerspectiveCamera(70,innerWidth/innerHeight,0.1,400);camera.position.z=1;
  const sizeIt=()=>{renderer.setSize(innerWidth,innerHeight);camera.aspect=innerWidth/innerHeight;camera.updateProjectionMatrix();};
  sizeIt();addEventListener('resize',sizeIt);

  const disc=(i,o)=>{const c=document.createElement('canvas');c.width=c.height=64;const x=c.getContext('2d');
    const g=x.createRadialGradient(32,32,0,32,32,32);g.addColorStop(0,i);g.addColorStop(.25,i);g.addColorStop(1,o);
    x.fillStyle=g;x.fillRect(0,0,64,64);return new THREE.CanvasTexture(c);};
  const starTex=disc('rgba(255,255,255,1)','rgba(255,255,255,0)');
  const glowTex=disc('rgba(140,255,250,.9)','rgba(47,230,224,0)');

  const f=ambient?0.55:1; // densité réduite en fond ambiant
  const layers=[];
  function makeStars(count,spread,size,color,tex){
    const g=new THREE.BufferGeometry();const pos=new Float32Array(count*3);
    for(let i=0;i<count;i++){pos[i*3]=(Math.random()-.5)*spread;pos[i*3+1]=(Math.random()-.5)*spread;pos[i*3+2]=-Math.random()*spread;}
    g.setAttribute('position',new THREE.BufferAttribute(pos,3));
    const m=new THREE.PointsMaterial({size,map:tex,color,transparent:true,blending:THREE.AdditiveBlending,depthWrite:false,sizeAttenuation:true,opacity:.95});
    const pts=new THREE.Points(g,m);scene.add(pts);return {pts,pos,spread,count};
  }
  layers.push(makeStars(Math.round(900*f),260,0.9,0xffffff,starTex));
  layers.push(makeStars(Math.round(500*f),200,1.5,0xbfeef0,starTex));
  layers.push(makeStars(Math.round(120*f),160,2.6,0x8bfff7,glowTex));

  const nt=(()=>{const c=document.createElement('canvas');c.width=c.height=256;const x=c.getContext('2d');
    const g=x.createRadialGradient(128,128,0,128,128,128);
    g.addColorStop(0,'rgba(120,255,247,.55)');g.addColorStop(.35,'rgba(47,230,224,.28)');
    g.addColorStop(.7,'rgba(20,120,140,.10)');g.addColorStop(1,'rgba(0,0,0,0)');
    x.fillStyle=g;x.beginPath();x.arc(128,128,128,0,7);x.fill();return new THREE.CanvasTexture(c);})();
  const nebs=[],nebColors=[0x2fe6e0,0x14a0b4,0x7affef,0x0f6f7a];
  const nebCount=ambient?7:14;
  for(let i=0;i<nebCount;i++){
    const m=new THREE.SpriteMaterial({map:nt,color:nebColors[i%nebColors.length],transparent:true,blending:THREE.AdditiveBlending,depthWrite:false,opacity:ambient?.32:.5});
    const s=new THREE.Sprite(m);s.position.set((Math.random()-.5)*140,(Math.random()-.5)*90,-20-Math.random()*180);
    const sc=30+Math.random()*70;s.scale.set(sc,sc,1);s.userData.spin=(Math.random()-.5)*.0006;scene.add(s);nebs.push(s);
  }

  const mouse={x:0,y:0},tgt={x:0,y:0};
  addEventListener('pointermove',e=>{tgt.x=(e.clientX/innerWidth-.5);tgt.y=(e.clientY/innerHeight-.5);},{passive:true});
  const clock=new THREE.Clock();
  (function loop(){
    requestAnimationFrame(loop);
    const dt=Math.min(clock.getDelta(),.05);
    layers.forEach((L,li)=>{const speed=(2.2+li*1.1)*(ambient?.5:1);
      const a=L.pos;
      for(let i=0;i<L.count;i++){a[i*3+2]+=speed*dt;if(a[i*3+2]>-1.5){a[i*3]=(Math.random()-.5)*L.spread;a[i*3+1]=(Math.random()-.5)*L.spread;a[i*3+2]=-L.spread;}}
      L.pts.geometry.attributes.position.needsUpdate=true;L.pts.rotation.z+=0.0002*(li+1)*(reduce?0:1);});
    nebs.forEach(s=>{s.material.rotation+=s.userData.spin;s.position.z+=0.9*dt*(ambient?.5:1);if(s.position.z>2){s.position.z=-200;s.position.x=(Math.random()-.5)*140;s.position.y=(Math.random()-.5)*90;}});
    mouse.x+=(tgt.x-mouse.x)*.04;mouse.y+=(tgt.y-mouse.y)*.04;
    const k=ambient?3:8;
    camera.position.x+=((mouse.x*k)-camera.position.x)*.05;
    camera.position.y+=((-mouse.y*(k*.6))-camera.position.y)*.05;
    camera.lookAt(mouse.x*4,-mouse.y*3,-30);
    renderer.render(scene,camera);
  })();
}

/* ====== CONTACT LINKS (page contact) ====== */
function wireContact(){
  const ig=document.getElementById('ctcIg'); if(ig) ig.href=CONTACT.instagram;
  const sc=document.getElementById('ctcSc'); if(sc) sc.href=CONTACT.snapchat;
  const ml=document.getElementById('ctcMl'); if(ml) ml.href='mailto:'+CONTACT.email;
  const me=document.getElementById('ctcMlVal'); if(me) me.textContent=CONTACT.email;
}

/* ====== INIT ====== */
buildServices();
buildPortfolio();
buildReviews();
/* ====== LAISSER UN AVIS (publication publique via Firestore) ====== */
function wireReviewForm(){
  const btn=document.getElementById('revAddBtn'), form=document.getElementById('revForm'), grid=document.getElementById('revGrid');
  const cta=document.querySelector('.rev-cta');
  if(!btn||!form||!grid) return;
  if(!FIREBASE_ENABLED){ if(cta) cta.style.display='none'; return; }
  let rating=0;
  btn.addEventListener('click',()=>{
    if(form.hasAttribute('hidden')){form.removeAttribute('hidden');btn.textContent='Fermer';form.scrollIntoView({behavior:'smooth',block:'center'});}
    else{form.setAttribute('hidden','');btn.textContent='Laisser un avis';}
  });
  const stars=[...document.querySelectorAll('#rvStars button')];
  const paint=n=>stars.forEach((s,i)=>s.classList.toggle('on',i<n));
  stars.forEach((s,i)=>{s.addEventListener('click',()=>{rating=i+1;paint(rating);});s.addEventListener('mouseenter',()=>paint(i+1));});
  const wrap=document.getElementById('rvStars'); if(wrap) wrap.addEventListener('mouseleave',()=>paint(rating));
  const flag=el=>{el.style.borderColor='var(--gold)';el.focus();el.addEventListener('input',()=>el.style.borderColor='',{once:true});};
  const sendBtn=document.getElementById('rvSend'), hint=document.getElementById('rvHint');
  sendBtn.addEventListener('click',()=>{
    const name=document.getElementById('rv-name').value.trim();
    const biz=document.getElementById('rv-biz').value.trim();
    const msg=document.getElementById('rv-msg').value.trim();
    if(!name){flag(document.getElementById('rv-name'));return;}
    if(!rating){wrap.animate([{transform:'translateX(0)'},{transform:'translateX(-6px)'},{transform:'translateX(6px)'},{transform:'translateX(0)'}],{duration:300});return;}
    if(!msg){flag(document.getElementById('rv-msg'));return;}
    const r={n:name,t:biz||'Client',s:rating,q:msg};
    sendBtn.disabled=true; if(hint) hint.textContent='Publication en cours…';
    submitPublicReview(r).then(()=>{
      const el=document.createElement('div');el.className='rev';el.innerHTML=reviewCardHTML(r);
      grid.insertBefore(el,grid.firstChild);
      el.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'none'}],{duration:500,easing:'ease'});
      form.reset();rating=0;paint(0);
      form.setAttribute('hidden','');btn.textContent='Laisser un avis';
      sendBtn.disabled=false; if(hint) hint.textContent="Votre avis est publié publiquement sur le site.";
      el.scrollIntoView({behavior:'smooth',block:'center'});
    }).catch(()=>{
      sendBtn.disabled=false; if(hint) hint.textContent="Échec de la publication, réessaie dans un instant.";
    });
  });
}
wireReviewForm();
buildClients();
buildDevis();
wireContact();
renderFloat();
observeReveals();
initGalaxy();
